<template>
    <div>
        <template v-for="( key, index ) in headers">
            <span
                v-if="key === 'name'"
                :class="[
                    'table__body__row__text position--relative',
                    `table__${model}__col__${index}`
                ]"
                :key="index"
            >
                {{ row[key] || ''}}
            </span>
            <span
                v-else
                :class="[
                    'position--relative',
                    `table__${model}__col__${index}`
                ]"
                :key="index"
            >
                <span :class="`row__script__state row__script__state--${row.enabled ? 'active' : 'disabled' } display--inline-b`"></span>
            </span>
        </template>
        <div
            :class="[
                'row__script__actions display--flex',
                `table__${model}__col__2`,
                { 'row__script__actions--end': row.enabled || !$store.getters.can( 'script', 'edit' ) }
            ]"
        >
            <table-actions
                v-if="!row.enabled"
                :settings="{
                    model: 'script',
                    active: {
                        action: activeScript
                    },
                    delete: {
                        action: deleteScript
                    }
                }"
            />
            <router-link
                :to="`/campaigns/${$route.params.id}/scripts/${row.id}`"
                class="table__body__row__icon row__script__anchor position--relative accessibility--button"
            >
                <icon-info class="row__script__icon"/>
            </router-link>
        </div>
    </div>
</template>

<script>
// store
import { useActions } from '@/hooks/use-store';

// hooks
import tableStructure from '@/hooks/use-table';

export default {
    components: {
        TableActions: () => import( /* webpackChunkName: 'TableActions' */ '@/components/bundles/tables/packs/TableActions' ),
        IconInfo: () => import( /* webpackChunkName: 'IconInfo' */ '@/components/bundles/layout/images/icons/IconInfo' )
    },
    ...tableStructure,
    setup ( props, { parent, root }) {
        // obtenção das acções da store.
        const { actions } = useActions();

        /**
         * [method]
         * Emissão das configurações da página, como
         * o bloqueio da barra de acções e abertura
         * da modal de confirmação.
         *
         * @param {String} type
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const emitConfigs = ( type = 'active' ) => {
            // bloqueia a barra de adição & edição.
            actions( 'controlActionBar', { value: true });

            // trigger para abrir a modal.
            parent.$emit( 'open-modal', { actionType: type });
        };

        /**
         * [method]
         * Activação do guião.
         * É emitido as configs & definição dos
         * valores a serem enviados para API.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const activeScript = () => {
            emitConfigs();

            // definição dos valores a serem enviados para API.
            actions( 'registerField', { name: 'method', value: 'put' });
            actions( 'registerField', { name: 'id', value: props.row.id });
            actions( 'registerField', { name: 'stateId', value: 1 });
        };

        /**
         * [method]
         * Apagar do guião.
         * É emitido as configs & definição dos
         * valores a serem enviados para API.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const deleteScript = () => {
            emitConfigs( 'delete' );

            // definição do ID.
            actions( 'registerField', { name: 'id', value: props.row.id });
            actions( 'registerField', { name: 'endpoint', value: `/campaigns/${root.$route.params.id}/scripts` });
        };

        return { activeScript, deleteScript };
    }
};
</script>

<style lang="scss">
    .row {
        &__script {
            &__state {
                @include dimensions( 26px, 26px );
                @include rounded-corner( 50% );
                &--active {
                    background: $color-green;
                }
                &--disabled {
                    background: $color-red;
                }
            }
            &__anchor {
                height: 26px;
            }
            &__icon {
                @include dimensions( 26px, 26px );
            }
            &__actions {
                gap: 10px;
                &--end {
                    justify-content: flex-end;
                }
            }
        }
    }
</style>